import { Chip } from "@/components/Chip";
import { FiCheck } from "react-icons/fi"

//TODO: BenefitsList should be a refactor of RichtextBlock list component.
export const BenefitsList = ({ list, active }) => {
  if(!list) return null;

  return list.map(benefit => (
    <li
      key={benefit.item}
      className="u-flex plan-box__list u-spacing-1 box__ul">
      <span className="body-l u-grey-600">
        <FiCheck color="#737373" />
      </span>
      <span
        className={active ? "" : "u-grey-600"}
        dangerouslySetInnerHTML={{ __html: benefit.item }} />
        {benefit.component === "chip" && (
          <Chip
            label={benefit.label}
            type="outlined"
            color="success"
          />
      )}
    </li>
  ));
}
